export default {
    i18n: {
        "day": "일",
        "Device Information": "장치 정보",
        "handset": "핸드셋",
        "Access Denied.": "문을 열지 못했습니다.",
        "Fingerprint": "지문",
        "tamperAlarm": "장치 훼손 경보",
        "Http": "HTTP",
        "Date Time": "날짜 시간",
        "Card": "카드",
        "name": "이름",
        "Device Name": " 디바이스 이름",
        "auto": "자동",
        "Group": "그룹",
        "Volume": "볼륨",
        "minutes": "분",
        "timezone": "시간대",
        "Are you sure you want to delete this device?": "해당 디바이스를 삭제하시겠습니까?",
        "Attendance Point Name": "출퇴근 지점 이름",
        "Mac": "MAC",
        "confirmToDeleteIt?": "정말 삭제 하시겠습니까?",
        "captureLogs": "캡쳐 로그",
        "Doors": "출입문",
        "All Doors": "모든 출입문",
        "Lock List": "잠금장치 목록",
        "Link Device Relay": "장치 릴레이 연결",
        "Added Successfully!": "성공적으로 추가됨!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "락장치가 릴레이와 연결되면 릴레이가 트리거될 때 잠금이 해제됩니다.",
        "Adding...": "추가 중",
        "Please try again 24 hours later.": "24시간 후에 다시 시도해 주세요.",
        "Action": "동작",
        "unlock": "문열기",
        "Address": "주소",
        "Owner": "소유자",
        "Failed": "실패",
        "Timeout": "시간초과",
        "Response": "응답",
        "caller": "발신자",
        "receiver": "수신인",
        "doorLogs": "도어 로그 ",
        "callHistory": "통화 내역",
        "UID": "UID",
        "Call Type": "통화 타입",
        "Code": "코드",
        "User": "사용자",
        "Device List": "디바이스 목록",
        "Model": "모델",
        "Time": "시간",
        "Company": "회사",
        "Property Managers": "건물관리자",
        "Current Version": "현재 버전",
        "indoorMonitor": "월패드",
        "guardPhone": "경비실 전화기",
        "close": "닫기",
        "Success": "성공",
        "URL": "URL",
        "Please select a device.": "디바이스를 선택하십시오.",
        "Password is too weak.": "비밀번호가 너무 약합니다.",
        "Company is required.": "회사는 필수 항목입니다.",
        "Your account is not activated, please contact your service provider.": "계정이 활성화되지 않았습니다.  서비스 제공업체에 문의하십시오.",
        "Language": "언어",
        "Face": "얼굴",
        "Please set at least one access type.": "접근 유형을 하나 이상 설정하세요.",
        "Please contact your service provider to activate this advanced feature.": "이 고급 기능을 활성화하려면 서비스 제공자에 문의하세요.",
        "Community name": "커뮤니티 이름",
        "Please enable PM App first.": "먼저 PM 앱을 활성화하세요.",
        "Username": "사용자 이름",
        "Change Log": "변경로그",
        "Assign": "할당",
        "Floor": "층",
        "Link Device": "연결 디바이스",
        "Accessible Floors": "접근 가능한 층",
        "Upgrade": "업그레이드",
        "Function": "기능",
        "callDuration": "통화 시간",
        "No": "아니오",
        "Verification Code": "확인 코드",
        "Expiration Time": "만료시간",
        "PIN": "비밀번호",
        "MAC": "MAC",
        "Building": "건물(동)",
        "APT": "아파트",
        "ID": "ID",
        "Name": "이름",
        "activities": "로그",
        "Obtain": "취득",
        "call": "통화",
        "Group Call": "그룹 호출",
        "Delete": "삭제",
        "Yes": "예",
        "Door Release PIN": "문 열기 PIN",
        "Email": "이메일",
        "Mobile Number doesn\'t exist.": "휴대폰 번호가 없습니다.",
        "Tips": "알림",
        "Password": "비밀번호",
        "The end time cannot be earlier than the start time.": "종료시간은 시작시간보다 빠를 수 없습니다.",
        "Back": "뒤로",
        "File format error.": "파일 형식 오류.",
        "motionDetection": "모션감지",
        "You are trying too often, please try again in 5 minutes": "너무 자주 시도하고 있습니다, 5분 후에 다시 시도하십시오",
        "User name too long.": " 사용자 이름이 너무 깁니다.",
        "This MAC address is redirected on RPS.": "이 MAC 주소는 RPS에서 리디렉션됩니다.",
        "No Answer": "무응답",
        "failedToUnlock": "문열림 실패",
        "visitor": "방문자",
        "yesterday": "어제",
        "Too large data! Please first export the data before %s first,thanks.": "데이터가 너무 큽니다! 먼저 %s 이전의 데이터를 먼저 내보내주세요.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "미결제 주문이 있는지 확인하고, 없으면 서비스 제공업체에 문의하세요.",
        "lock": "잠금",
        "open": "열기",
        "The PersonalAccount is not active.": "개인 계정이 활성화되지 않았습니다.",
        "You cannot link an account that already link other accounts.": "이미 다른 계정을 연결한 계정은 연결할 수 없습니다.",
        "You cannot link multiple property manager accounts under the same installer account.": "동일한 설치 관리자 계정으로는 여러 건물관리자 계정을 연결할 수 없습니다.",
        "You cannot link to the currently logged in account.": "현재 로그인한 계정에는 연결할 수 없습니다.",
        "nfc": "NFC",
        "Delete Device": "장치 삭제",
        "date": "날짜",
        "Device deleted successfully": "디바이스가 성공적으로 삭제되었습니다.",
        "Failed to delete device": "디바이스를 삭제하지 못했습니다.",
        "Are you sure you want to cancel?": "취소하시겠습니까?",
        "Unlimited": "무제한",
        "Password Incorrect.": "비밀번호가 올바르지 않습니다.",
        "deliverySystemVerification": "전송 시스템 검증",
        "None": "없음",
        "Upgrading...": "업그레이드 중...",
        "amenityReservation": "커뮤니티 예약",
        "idAccess": "ID 액세스",
        "RF Card": "RF 카드",
        "exitButton": "문열림 버튼",
        "Please select at least one item.": "하나 이상의 항목을 선택해 주세요.",
        "The ID can contain only digits and letters, up to 32 characters.": "아이디에는 숫자와 문자만 포함할 수 있으며 최대 32자까지 입력할 수 있습니다.",
        "The PIN is not available.": "비밀번호를 사용할 수 없습니다.",
        "Change WiFi": "WiFi 변경",
        "Phone number": "전화번호",
        "Invalid {0}.": "잘못된 {0}입니다.",
        "{0} already exists.": "{0}이(가) 이미 존재합니다.",
        "Operation failed!": "작업이 실패했습니다!",
        "Failed to get data.": "데이터를 가져오지 못했습니다.",
        "You do not have the necessary permissions to perform this operation.": "이 작업을 수행하는 데 필요한 권한이 없습니다.",
        "You can only import one template at a time in the current site.": "현재 사이트에서는 한 번에 하나의 템플릿만 가져올 수 있습니다.",
        "Delivery name": "택배원 권한 이름",
        "MAC address not in the MAC library.": "MAC 라이브러리에 없는 MAC 주소입니다.",
        "Please delete devices under this building.": "이 건물 아래에 있는 디바이스를 삭제하세요.",
        "The start time cannot be later than the end time.": "시작 시간은 종료 시간보다 늦을 수 없습니다.",
        "emergency action type": "긴급 조치 유형",
        "Only 1000 data items can be imported at a time.": "한 번에 1,000개의 데이터 항목만 가져올 수 있습니다.",
        "The password is too short.": "비밀번호가 너무 짧습니다.",
        "The data has been updated. Please refresh the page and try again.": "데이터가 업데이트되었습니다. 페이지를 새로고침하고 다시 시도하세요.",
        "AutoP length must be less 2048 bytes.": "AutoP 길이는 2048바이트 미만이어야 합니다.",
        "File Check Failed": " 파일 확인 실패",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "관리자 계정 로그인이 만료되었습니다. 서비스 제공업체에 문의하세요.",
        "iqPinVerificationFailed": "IQ PIN 확인에 실패했습니다.",
        "accountBlacklisted": "계정이 블랙리스트에 등록되었습니다.",
        "outsideAuthorizedTime": "허가된 시간 외.",
        "network group": "네트워크 그룹",
        "Company name": "회사 이름",
        "Group name": "그룹 이름",
        "relay": "릴레이",
        "motionTime": "모션타임",
        "motionType": "모션 유형",
        "postalCode": "우편번호",
        "floor format": "층(플로어) 형식",
        "mobilePhone": "휴대폰",
        "time format": "시간 형식",
        "security relay": "보안 릴레이",
        "Param": "매개변수",
        "Offline Code": "오프라인 코드",
        "Add akubela Smart Locks": "아쿠벨라 스마트 잠금 장치 추가",
        "Module Version": "모듈 버전",
        "Lock Body Version": "잠금 장치 버전",
        "Available Version": "사용 가능한 버전",
        "Please wake up the lock screen and then upgrade.": "잠금 화면을 깨운 다음 업그레이드하세요.",
        "This process will take some time, please be patient.": "해당 작업은 다소 시간이 걸리니 조금만 기다려주세요.",
        "Please confirm that the WiFi network is functioning properly.": "WiFi 네트워크가 제대로 작동하는지 확인하세요.",
        "Please wake up the lock screen.": "잠금 화면을 깨워주세요.",
        "This lock has already been added to another apartment.": "이 잠금장치는 이미 다른 아파트에 추가되어 있습니다.",
        "This lock has already been added to the apartment.": "이 잠금장치는 이미 아파트에 추가되었습니다.",
        "Pin Code": "비밀번호",
        "Too many failed attempts, please try again in a few minutes.": "실패한 시도가 너무 많습니다. 몇 분 후에 다시 시도하세요.",
        "Login Account": "로그인 계정",
        "Same account cannot login in different ins.": "동일한 계정으로 다른 인스에 로그인할 수 없습니다.",
        "Lock Name": "잠금 이름",
        "Smart Locks": "스마트 잠금 장치",
        "Add Smart Lock": "스마트 잠금 추가",
        "The selected duration cannot be more than one year.": "선택한 기간은 1년을 초과할 수 없습니다.",
        "The end time of the break time cannot be later than the end work time.": "휴식 시간의 종료 시간은 근무 종료 시간보다 늦을 수 없습니다.",
        "The start time of the break time cannot be earlier than the start work time.": "휴식 시간의 시작 시간은 근무 시작 시간보다 빠를 수 없습니다.",
        "The end time of the valid check time cannot be earlier than the end work time.": "출퇴근 유효시간의 종료시간은 근무 종료시간보다 빠를 수 없습니다.",
        "The start time of the valid check time cannot be later than the start work time.": "출퇴근 유효시간의 시작시간은 근무 시작시간보다 늦을 수 없습니다.",
        "Deleting failed. The timetable is used by a shift.": "삭제하지 못했습니다. 근무조에서 해당 근무시간표를 사용합니다.",
        "Deleting failed. The shift is in use.": "삭제하지 못했습니다. 교대근무가 사용 중입니다.",
        "Deleting failed. The leave type is in use.": "삭제하지 못했습니다. 휴가 유형이 사용 중입니다.",
        "Valid time conflicts with an existing schedule.": "유효 시간이 기존 일정과 충돌합니다.",
        "The timing for multiple schedules must not coincide.": "여러 일정의 타이밍이 겹치면 안 됩니다.",
        "Attendance Log": "근태 기록",
        "Added Failed!": "추가 실패!",
        "Setting WiFi": "WiFi 설정",
        "License Plate": "차량번호",
        "key": " 키",
        "IQ Offline.": "IQ 오프라인.",
        "{0}Unlock": "{0} 잠금 해제",
        "automatically": "자동",
        "manually": "수동",
        "Video Storage": "비디오 스토리지",
        "Device(s) for Video Storage": "비디오 스토리지용 장치",
        "The amount of exported data is too large. Please export it in batches.": "내보낸 데이터의 양이 너무 많습니다. 일괄적으로 내보내주세요.",
        "Auto-record video when door unlocks": "도어 잠금 해제 시 비디오 자동 녹화",
        "Auto-record video during calls": "통화 중 동영상 자동 녹화",
        "Manual video recording in monitoring": "모니터링 시 수동 비디오 녹화",
        "Saved for 30days/60days/90days": "30일/60일/90일 동안 저장됨",
        "To subscribe, please contact your provider for activation.": "구독하려면 서비스 제공업체에 문의하여 활성화하세요.",
        "Saved for {0}days": "{0}일 동안 저장됨",
        "Subscribed Plan": "구독 요금제",
        "Supported Devices: {0}": "지원되는 장치: {0}",
        "{0}Lock": "{0} 잠금",
        "Video Saving": "비디오 저장",
        "Download Completed!": "다운로드 완료!",
        "Fail to download.": "다운로드에 실패했습니다.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "삭제에 실패했습니다! 건물관리자가 렌트매니저 고객에 바인딩되어 있으므로 먼저 삭제해야 합니다.",
        "No log to be exported.": "내보낼 로그가 없습니다.",
        "capture&Video": "캡처 및 비디오",
        "packageDetection": "택배 감지",
        "Time format is invalid.": "시간 형식이 잘못되었습니다.",
        "No permission to export logs of this type.": "해당 유형의 로그를 내보낼 권한이 없습니다.",
        "Project type is invalid.": "프로젝트 유형이 잘못되었습니다.",
        "Salto Account Blocked.": "살토 계정이 차단됨",
        "Remote open not in access group.": "원격으로 열 수 있는 권한이 액세스 그룹에 없습니다.",
        "SIP Account required.": "SIP 계정이 필요합니다.",
        "The PIN must be {0} digits.": "PIN은 {0}자리여야 합니다.",
        "gatewayConnectionUnavailable": "게이트웨이 연결을 사용할 수 없습니다.",
        "Invalid Username or Password": "잘못된 사용자 이름 또는 비밀번호입니다",
        "Account already linked to another user.": "계정이 이미 다른 사용자에게 연결되어 있습니다.",
        "The account has been added by another user.": "다른 사용자가 계정을 추가했습니다.",
        "Failed to add. This user already has 5 license plates.": "추가할 수 없습니다. 해당 사용자는 이미 차량번호 5개를 등록한 상태입니다.",
        "Please at least select a door.": "최소한 한 개의 문을 선택해 주시기 바랍니다.",
        "UHF Card": "UHF 카드",
        "personnel": "인원",
        "Parking Lot Name": "주차장 이름",
        "Controlled Relay": "제어 릴레이",
        "No Permission": "권한 없음",
        "Please ensure that all doors in the project are activated at the same time.": "프로젝트의 모든 문이 동시에 활성화되어 있는지 확인하세요.",
        "gatewayBusy": "게이트웨이가 사용중입니다.",
        "Please set the perimeter door group first.": "먼저 경계 문 그룹을 설정하세요.",
        "Please ensure that all doors in the project are renewed at the same time.": "프로젝트의 모든 문이 동시에 갱신되었는지 확인하세요.",
        "When lockdown is on, the controlled relay cannot be modified.": "폐쇄가 활성화된 경우 제어되는 릴레이를 수정할 수 없습니다.",
        "DetectionLogs": "감지 로그",
        "packageIn": "택배 반입",
        "packageOut": "택배 반출",
        "View Progress": "진행 상황 보기",
        "Check if the WiFi is operating on the 2.4GHz band.": "WiFi가 2.4GHz 대역에서 작동하는지 확인하세요.",
        "Verify that the WiFi password is correct.": "WiFi 비밀번호가 올바른지 확인하세요.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "핫스팟 구성 중에 올바른 장치 핫스팟에 연결되어 있는지 확인하세요.",
        "Offline Code Unlock": "오프라인 코드로 잠금 해제",
        "Salto Token Expired.": "Salto 토큰이 만료되었습니다.",
        "Lock Offline": "잠금장치 오프라인",
        "identity information! Please login again": "신원 정보! 다시 로그인해 주세요.",
        "Email is required.": "이메일을 입력해야 합니다.",
        "Mobile number is required.": "휴대폰 번호는 필수입니다.",
        "You can\'t make payments for offices in different time zones.": "다른 시간대에 있는 사무실에 대해서는 결제하실 수 없습니다.",
        "The current scheduling staff exceeds 200 people.": "현재 스케줄링 인원이 200명을 초과합니다.",
        "param": "매개변수",
        "Invalid UserName or Password": "사용자 이름 또는 비밀번호가 올바르지 않습니다.",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "귀하의 Salto KS 계정은 잠금장치 이름을 수정할 권한이 없습니다.",
        "Owner is required.": "소유자가 필요합니다.",
        "Office is required.": "사무실이 필요합니다.",
        "PIN or RF Card is required.": "PIN 또는 RF 카드가 필요합니다.",
        "RF card": "RF 카드",
        "Personnel is required.": "인원이 필요합니다.",
        "email address": "이메일 주소",
        "mobile number": "휴대폰 번호",
        "The length must be less than 32 characters.": "길이는 32자 미만이어야 합니다.",
        "The length must be less than 256 characters.": "길이는 256자 미만이어야 합니다.",
        "Access Group is required.": "액세스 그룹이 필요합니다.",
        "Device is required.": "기기가 필요합니다.",
        "Admin is required.": "관리자가 필요합니다.",
        "Mobile number": "휴대폰 번호",
        "schedules": "일정",
        "Timetable name": "시간표 이름",
        "Shift name": "근무조 이름",
        "Leave type": "휴가 종류",
        "recheck in time": "재체크인 시간",
        "recheck out time": "재퇴실 시간",
        "The building name": "건물 이름",
        "Building is required.": "건물이 필요합니다.",
        "selection, The same reader cannot be set for both entry and exit": "선택, 입구와 출구에 동일한 리더기를 설정할 수 없습니다.",
        "Door number": "문 번호",
        "door input cannot be selection duplicated.": "도어 입력은 중복 선택할 수 없습니다.",
        "Group is required.": "그룹이 필요합니다.",
        "Title can contain up to 32 characters.": "제목은 최대 32자까지 입력할 수 있습니다.",
        "Content can contain up to 1024 characters.": "콘텐츠에는 최대 1024자의 문자를 포함할 수 있습니다.",
        "Content can contain up to 64 characters.": "콘텐츠는 최대 64자까지 입력할 수 있습니다.",
        "Report is required.": "보고서가 필요합니다.",
        "ID is required.": "아이디가 필요합니다.",
        "The office does not exist.": "사무실이 존재하지 않습니다.",
        "Office name": "오피스 이름",
        "The Temp Key does not exist.": "임시 키가 존재하지 않습니다.",
        "autolock time": "자동 잠금 시간",
        "The User does not exist.": "해당 사용자가 존재하지 않습니다.",
        "The Installer does not exist.": "설치자가 존재하지 않습니다.",
        "The Project does not exist.": "프로젝트가 존재하지 않습니다.",
        "The Distributor does not exist.": "대리점이 존재하지 않습니다.",
        "The Community Device does not exist.": "커뮤니티 디바이스가 존재하지 않습니다.",
        "The Property Manager does not exist.": "커뮤니티 관리자(또는 부동산 관리자)가 존재하지 않습니다.",
        "The Sub Distributor does not exist.": "서브 대리점이 존재하지 않습니다.",
        "The Single Slave does not exist.": "해당 단일 거주자 계정이 존재하지 않습니다.",
        "The Property Manager EndUser does not exist.": "해당 부동산 관리자 최종 사용자가 존재하지 않습니다.",
        "The Family Member does not exist.": "해당 가족 구성원이 존재하지 않습니다.",
        "Set Failed!": "설정에 실패했습니다!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "오프라인 코드 요청은 30분 내 10회까지 가능합니다. 나중에 다시 시도해 주세요.",
        "This Email doesn\'t exist.": "이 이메일은 존재하지 않습니다.",
        "detection type": "감지 유형",
        "Device UUID": "디바이스 UUID",
        "smart lock device": "스마트 락 디바이스",
        "You are trying too often, please try again in 5 minutes.": "너무 자주 시도하고 있습니다. 5분 후에 다시 시도해 주세요.",
        "You can only import one file at a time. Please wait for the current import to finish.": "한 번에 하나의 파일만 가져올 수 있습니다. 현재 가져오기가 완료될 때까지 기다려 주세요.",
        "NVR Name": "NVR 이름",
        "NVR Address": "NVR 주소",
        "Stay Alarm": "체류 알람",
        "Happended On": "발생 시간",
        "Edit Milesight NVR": "Milesight NVR 편집",
        "Add Milesight NVR": "Milesight NVR 추가",
        "Auto-record video on motion detection, package detection": "동작 감지, 택배 감지 시 자동 영상 녹화",
        "A 7-day free trial is included with your subscription.": "구독 시 7일 무료 체험 기간이 포함됩니다.",
        "For service renewal, please reach out to your provider.": "서비스 갱신을 위해서는 서비스 제공업체에 문의하세요.",
        "Allow the Property Manager to view recorded videos": "부동산 관리자가 녹화된 영상을 볼 수 있도록 허용",
        "Please ensure the WiFi network is working properly.": "WiFi 네트워크가 제대로 작동하는지 확인하세요.",
        "Edit akubela Smart Locks": "아쿠벨라 스마트 잠금 장치 편집",
        "Upgraded Successfully!": "업그레이드 성공!!",
        "Upgraded Failed!": "업그레이드 실패!",
        "Editing...": "편집 중...",
        "Edited successfully!": "수정 성공!!",
        "Edited Failed!": "수정 실패!",
        "Downloading video...": "비디오를 다운로드하는 중...",
        "All Locks": "모든 잠금 장치",
        "Select Locks": "잠금장치 선택",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "{0}자리 PIN은 아쿠벨라 스마트 잠금장치가 네트워크에 연결되면 사용할 수 있습니다. 동기화 후 PIN이 적용되기까지 시간이 다소 소요될 수 있습니다.",
        "Please at least select a door or a lock.": "최소한 문이나 자물쇠를 선택해 주세요.",
        "This lock has already been added to your apartment.": "해당 잠금장치는 이미 귀하의 아파트에 추가되었습니다.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "이 잠금장치는 이미 다른 아파트에 추가되었습니다. 도움이 필요하면 서비스 제공업체에 문의하세요.",
        "LockBody Version": "잠금바디 버전",
        "Two-factor Authentication": "2단계 인증",
        "Monitoring Scope": "모니터링 범위",
        "Stay Duration": "체류 기간",
        "Volume Settings": "볼륨 설정",
        "get card list for lock error": "잠금 장치의 카드 목록을 가져오는 데 오류가 발생했습니다.",
        "get card list parse fail": "카드 목록을 해석하는 데 실패했습니다.",
        "get pin list for lock error": "잠금 장치의 PIN 목록을 가져오는 데 오류가 발생했습니다.",
        "get pin list parse fail": "PIN 목록을 해석하는 데 실패했습니다.",
        "fingerprint code must be less than 2048 characters or empty.": "지문 코드는 2048자 미만이거나 비어 있어야 합니다.",
        "Personnel not in office.": "직원이 사무실에 없습니다.",
        "customize form fail.": "맞춤 양식 생성에 실패했습니다.",
        "smart lock type error.": "스마트 잠금 장치 유형 오류입니다.",
        "invalid client id or secret": "잘못된 클라이언트 ID 또는 시크릿입니다.",
        "invalid account or password": "잘못된 계정 또는 비밀번호입니다.",
        "invalid access token": "유효하지 않은 액세스 토큰입니다.",
        "invalid refresh token": "유효하지 않은 리프레시 토큰입니다.",
        "no permission to access this project": "이 프로젝트에 접근할 권한이 없습니다.",
        "Stay Alarm Time": "알람 유지 시간",
        "This function only support sl20 lock.": "이 기능은 sl20 잠금 장치만 지원합니다.",
        "Json marshal error.": "Json 변환 오류입니다.",
        "Json unmarshal error.": "Json 해제 오류입니다.",
        "Illegal request, not added within valid time.": "유효한 시간 내에 추가되지 않아 부적합한 요청입니다.",
        "invalid nvr type": "유효하지 않은 NVR 유형입니다.",
        "project is empty": "프로젝트가 비어 있습니다.",
        "project type is invalid": "프로젝트 유형이 유효하지 않습니다.",
        "owner is invalid": "소유자가 유효하지 않습니다.",
        "url is invalid": "URL이 유효하지 않습니다.",
        "password is invalid": "비밀번호가 유효하지 않습니다.",
        "building is invalid": "빌딩이 유효하지 않습니다.",
        "fail to get data": "데이터를 가져오는 데 실패했습니다.",
        "invalid allow pm view type": "유효하지 않은 PM 보기 유형입니다.",
        "Data not exist.": "데이터가 존재하지 않습니다.",
        "cannot find community PrivateKey.": "커뮤니티 개인 키를 찾을 수 없습니다.",
        "cannot find single PrivateKey.": "단일 개인 키를 찾을 수 없습니다.",
        "The third party not exist.": "제3자가 존재하지 않습니다.",
        "{0} and indoor monitors/guard phones": "{0} 및 월패드/경비실 폰",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} 및 월패드/경비실 폰, 전화기를 백업으로 사용",
        "Indoor monitors/guard phones with {0} as backup": "월패드/경비실 폰 {0}을 백업으로 사용",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "{0}을 백업으로 사용하는 월패드/경비실 폰, 마지막으로 폰",
        "{0} Intercom Feature": "{0} 인터콤 기능",
        "Capture on {0}": "{0}에서 스냅샷 캡처",
        "{0} Intercom Feature is not activated or has expired.": "{0} 인터콤 기능이 활성화되지 않았거나 만료되었습니다.",
        "fingerprint code must be equal 1620 characters or empty.": "지문 코드는 1620자와 같거나 비어 있어야 합니다.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "업그레이드 성공을 위해 잠금장치의 배터리 잔량이 40% 이상인지 확인한 뒤 진행하세요.",
        "Automatic Locking Time": "자동 잠금 시간",
        "WiFi Keep-Alive": "Wi-Fi 유지",
        "WiFi Setting": "Wi-Fi 설정",
        "Connecting the network...": "네트워크 연결 중...",
        "Set successfully!": "설정 완료!",
        "The offline code can be used even if the lock is not connected to WiFi.": "잠금장치가 Wi-Fi에 연결되어 있지 않아도 오프라인 코드를 사용할 수 있습니다.",
        "Enabling this feature will increase the lock\'s power consumption.": "이 기능을 활성화하면 잠금장치의 전력 소비가 증가합니다.",
        "Each offline code can only be used once.": "각 오프라인 코드는 한 번만 사용할 수 있습니다.",
        "Receiver Info": "수신자 정보",
        "log id": "로그인 ID",
        "Create HW SN Config Empty SN.": "Huawei SN 구성 생성에 빈 SN이 있습니다.",
        "The SN": "SN(일련 번호)",
        "SN can contain up to 32 characters.": "SN은 최대 32자까지 입력할 수 있습니다.",
        "Check HW SN Not Found.": "Huawei SN을 찾을 수 없습니다.",
        "the end user not found": "최종 사용자를 찾을 수 없습니다.",
        "Family Call": "가족 전화",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "업그레이드 중에는 잠금장치 관련 모든 기능을 일시적으로 사용할 수 없습니다.",
        "8-digit PIN code starting with \"9\" is invalid!": "\"9\"로 시작하는 8자리 핀번호는 사용할 수 없습니다!",
        "Lock name length must be between 1 and 50": "락 이름의 길이는 1자에서 50자 사이여야 합니다.",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "휴대폰 번호 호출 서비스를 이용하는 인원 수는 {0} 인터콤 서비스를 이용하는 인원 수를 초과할 수 없습니다.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "휴대폰 번호 호출 서비스를 보유한 관리자 수는 {0} 인터콤 서비스를 보유한 관리자 수를 초과할 수 없습니다.",
        "charge type": "요금 유형",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "유선 전화 서비스를 이용하는 인원 수는 SmartPlus 인터콤을 이용하는 인원 수를 초과할 수 없습니다.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "유선 전화 서비스를 이용하는 관리자 수는 SmartPlus 인터콤을 이용하는 관리자 수를 초과할 수 없습니다.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "리더기는 Wiegand와 RS485를 동시에 사용하도록 구성할 수 없습니다.",
        "parameter error": "파라미터 오류",
        "community name already exist": "커뮤니티 이름이 이미 존재합니다.",
        "personnel app without intercom feature number": "인터폰 기능이 없는 인원용 앱 번호",
        "check feature billing charge plan new error": "기능 과금 요금제 확인 새 오류",
        "subscription not found": "구독을 찾을 수 없습니다.",
        "System setting record not found.": "시스템 설정 기록을 찾을 수 없습니다.",
        "Smart home not enabled.": "스마트홈이 활성화되지 않았습니다.",
        "the apt call type value is invalid.": "apt 호출 방식 값이 올바르지 않습니다.",
        "the ip call or sip call value is invalid.": "IP 호출 또는 SIP 호출 값이 올바르지 않습니다.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode는 2~8자리 숫자여야 하며, 9로 시작하는 8자리 숫자이거나 비어 있을 수 없습니다.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard는 A-F0-9여야 하며 16자리 미만 또는 비어 있어야 합니다.",
        "owner cannot be empty.": "소유자는 비워둘 수 없습니다.",
        "creator cannot be empty.": "생성자는 비워둘 수 없습니다.",
        "the creator type value is invalid": "생성자 유형 값이 올바르지 않습니다.",
        "the IsCreateByPm value is invalid": "IsCreateByPm 값이 올바르지 않습니다.",
        "the pinCode already exist": "pinCode가 이미 존재합니다.",
        "the rfCard already exist": "rfCard가 이미 존재합니다.",
        "license plate is invalid.": "차량 번호판이 올바르지 않습니다.",
        "owner info is invalid.": "소유자 정보가 올바르지 않습니다.",
        "uhf is invalid.": "uhf가 올바르지 않습니다.",
        "time control is invalid.": "시간 제어가 올바르지 않습니다.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "등록 가능한 차량번호 5개 한도에 도달하여 추가할 수 없습니다.",
        "the plate already exist": "차량 번호판이 이미 존재합니다.",
        "the uhf already exist": "uhf가 이미 존재합니다.",
        "empty community": "빈 커뮤니티",
        "no find license Plate": "차량 번호판을 찾을 수 없습니다.",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess 모드는 0, 1, 2 중 하나여야 합니다.",
        "Run field is required when mode is 1 or 2.": "모드가 1 또는 2일 때 Run 필드는 필수입니다.",
        "Serial field is required when mode is 2.": "모드가 2일 때 Serial 필드는 필수입니다.",
        "the pin cannot be empty": "pin은 비워둘 수 없습니다.",
        "the rfCard cannot be empty": "rfCard는 비워둘 수 없습니다.",
        "the IDAccess already exist": "IDAccess가 이미 존재합니다.",
        "the resident cannot be empty": "거주자는 비워둘 수 없습니다.",
        "the fingerprint cannot be empty": "지문은 비워둘 수 없습니다.",
        "the face cannot be empty": "얼굴은 비워둘 수 없습니다.",
        "not found pin": "pin을 찾을 수 없습니다.",
        "not found rfCard": "rfCard를 찾을 수 없습니다.",
        "not found IDAccess": "IDAccess를 찾을 수 없습니다.",
        "not found fingerprint": "지문을 찾을 수 없습니다.",
        "not found face": "얼굴을 찾을 수 없습니다.",
        "face pic is invalid.": "얼굴 사진이 올바르지 않습니다.",
        "community build and room cannot be empty.": "커뮤니티 건물과 방은 비워둘 수 없습니다.",
        "device info mac cannot be empty.": "디바이스 정보 mac은 비워둘 수 없습니다.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "스케줄러 유형은 0, 1, 2이어야 하며, 시간이 올바른 형식이어야 하고 dataflag는 0에서 127 사이여야 합니다.",
        "MAC address cannot be empty.": "MAC 주소는 비워둘 수 없습니다.",
        "MAC address 0C1105000000 is not allowed.": "MAC 주소 0C1105000000은 사용할 수 없습니다.",
        "MAC address must be 12 hexadecimal characters.": "MAC 주소는 12자리 16진수여야 합니다.",
        "Scheduler type value is invalid.": "스케줄러 유형 값이 올바르지 않습니다.",
        "parse is fail": "분석에 실패하였습니다.",
        "the fingerprint already exist": "지문이 이미 존재합니다.",
        "the licensePlate cannot be empty": "차량 번호판은 비워둘 수 없습니다.",
        "the licensePlate already exist": "차량 번호판이 이미 존재합니다.",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run은 10자리 숫자이거나 -K로 끝나야 합니다.",
        "idaccess serial must be 9 digit number.": "idaccess serial은 9자리 숫자여야 합니다.",
        "relay not in 0-15": "릴레이는 0~15 사이여야 합니다.",
        "security relay not in 0-3": "보안 릴레이는 0~3 사이여야 합니다.",
        "file name is wrong": "파일 이름이 올바르지 않습니다.",
        "access mode specified": "지정된 접근 모드",
        "create community user accessmode failed.": "커뮤니티 사용자 접근 모드 생성에 실패하였습니다.",
        "delete community user accessmode failed.": "커뮤니티 사용자 접근 모드 삭제에 실패하였습니다.",
        "Cannot delete building because it has associated users.": "해당 건물에 연관된 사용자가 있어 삭제할 수 없습니다.",
        "Cannot delete building because it has associated Salto devices.": "연결된 Salto 장치가 있어 건물을 삭제할 수 없습니다.",
        "community building not found": "커뮤니티 건물을 찾을 수 없습니다.",
        "Invalid Name Display": "잘못된 이름 표시",
        "The Community does not exist.": "해당 커뮤니티가 존재하지 않습니다.",
        "Update CommunityIsInstallerKit Error.": "CommunityIsInstallerKit 업데이트 오류.",
        "Dis Not SupportCommunityCalls Error.": "딜러가 커뮤니티 콜을 지원하지 않는 오류.",
        "Community Has Special Device, Not Allowed To Delete.": "커뮤니티에 특수 장치가 있어 삭제할 수 없습니다.",
        "The project smart home switch must be disabled": "프로젝트 스마트홈 스위치는 비활성화되어야 합니다.",
        "There are ITec Locks in project": "프로젝트에 ITec 잠금 장치가 있습니다.",
        "There are Salto Locks in project": "프로젝트에 Salto 잠금 장치가 있습니다.",
        "There are Dormakaba Locks in project": "프로젝트에 Dormakaba 잠금 장치가 있습니다.",
        "It is rent manager project": "렌트 매니저 프로젝트입니다.",
        "It is installer account": "설치기사 계정입니다.",
        "contact preference type": "통화 선호 유형",
        "Floor list is required when not all floors.": "모든 층이 아닐 경우 층 목록이 필요합니다.",
        "Building floors list is required when all buildings.": "모든 건물일 경우 건물 층 목록이 필요합니다.",
        "Indoor monitor name is required.": "실내 모니터 이름은 필수입니다.",
        "The primary account is not activated.": "주계정이 활성화되어 있지 않습니다.",
        "You can\'t create more family member accounts.": "더 이상 가족 구성원 계정을 만들 수 없습니다.",
        "community user not found": "커뮤니티 사용자를 찾을 수 없습니다.",
        "community is empty": "커뮤니티가 비어 있습니다.",
        "the end user not master user": "최종 사용자가 마스터 계정 사용자가 아닙니다.",
        "the end user not member user": "최종 사용자가 멤버 계정 사용자가 아닙니다.",
        "The email already exists and cannot be repeated": "이메일이 이미 존재하며 중복될 수 없습니다.",
        "The mobile Number already exists": "휴대폰 번호가 이미 존재합니다.",
        "The room number format error.": "방 번호 형식 오류입니다.",
        "community not found": "커뮤니티를 찾을 수 없습니다.",
        "resident not found": "거주자를 찾을 수 없습니다.",
        "installer not found": "설치기사를 찾을 수 없습니다.",
        "Operation Failed!": "작업에 실패하였습니다!",
        "You don\'t have operate permission": "작업 권한이 없습니다.",
        "You cannot select Relay and Door at the same time": "릴레이와 도어를 동시에 선택할 수 없습니다.",
        "user don\'t active": "사용자가 활성화되어 있지 않습니다.",
        "User has expired": "사용자 계정이 만료되었습니다.",
        "timestamp must be within 3 minutes of current server time": "타임스탬프는 현재 서버 시간에서 3분 이내여야 합니다.",
        "cannot find single rf Card.": "단일 rf Card를 찾을 수 없습니다.",
        "cannot find community rf Card.": "커뮤니티 rf Card를 찾을 수 없습니다.",
        "smartLock model": "스마트락 모델",
        "the project does not open smart home": "해당 프로젝트에 스마트홈이 활성화되어 있지 않습니다.",
        "php web server error": "php 웹 서버 오류",
        "Ins not found.": "Ins를 찾을 수 없습니다.",
        "RentManage Unit Not Set.": "RentManage 단위가 설정되지 않았습니다.",
        "add audit log error": "감사 로그 추가 오류",
        "check building in error": "건물 확인 오류",
        "Special devices cannot be deleted": "특수 장치는 삭제할 수 없습니다.",
        "the email is empty": "이메일이 비어 있습니다.",
        "the email format is incorrect": "이메일 형식이 올바르지 않습니다.",
        "the mobile number is empty": "휴대폰 번호가 비어 있습니다.",
        "the mobile number format is incorrect": "휴대폰 번호 형식이 올바르지 않습니다.",
        "Site not found": "프로젝트를 찾을 수 없습니다.",
        "User not found": "사용자를 찾을 수 없습니다.",
        "invalid time format": "올바르지 않은 시간 형식입니다.",
        "ground floor type": "중간 층 형식",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "시작 층 범위 오류, 유효 값은 -10~ -1, G0, G1, G2, 1~128입니다.",
        "Building ID must be between 1 and 99.": "건물 ID는 1과 99 사이여야 합니다.",
        "Community building name": "커뮤니티 건물 이름",
        "Building ID already exists in this community.": "이 커뮤니티에 이미 존재하는 건물 ID입니다.",
        "building ID": "건물 ID",
        "Community building not found.": "커뮤니티 건물을 찾을 수 없습니다.",
        "Cannot delete building because it has associated devices.": "해당 건물에 연관된 장치가 있어 삭제할 수 없습니다.",
        "project is not valid": "프로젝트가 올바르지 않습니다.",
        "Cannot delete building because it has associated salto devices.": "해당 건물에 연관된 salto 장치가 있어 삭제할 수 없습니다.",
        "Cannot delete building because it has associated iTec devices.": "해당 건물에 연관된 iTec 장치가 있어 삭제할 수 없습니다.",
        "Cannot delete building because it has associated dormakaba devices.": "해당 건물에 연관된 dormakaba 장치가 있어 삭제할 수 없습니다.",
        "member limit num": "멤버 제한 수",
        "Indoor Monitor No Set Error.": "실내 모니터가 설정되지 않았습니다.",
        "The room not has indoor": "방에 실내기가 없습니다.",
        "check user in building error": "건물에서 사용자 오류 확인",
        "The name specified is already in use.": "지정한 이름이 이미 사용 중입니다.",
        "This timeblock overlaps with an existing one. Please adjust it.": "이 시간대가 기존 시간대와 겹칩니다. 조정해 주세요.",
        "This door status changed. Please try again.": "문 상태가 변경되었습니다. 다시 시도해 주세요.",
        "the lock can\'t bind this community": "이 잠금장치는 이 커뮤니티를 연결할 수 없습니다.",
        "The custom quantity limit has been exceeded!": "사용자 지정 수량 한도를 초과했습니다!",
        "This time span overlaps with an existing one. Please adjust it.": "이 시간 범위가 기존 시간 범위와 겹칩니다. 조정해 주세요.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "이번 일회성 일정이 기존 일회성 일정의 유효 시간과 겹칩니다. 조정해 주세요.",
        "Operation Failed. Please try again.": "작업에 실패했습니다. 다시 시도해 주세요.",
        "The image is not a front view.": "이 이미지는 정면이 아닙니다.",
        "A mask was detected.": "마스크가 감지되었습니다.",
        "The image resolution is too low.": "이미지 해상도가 너무 낮습니다.",
        "No face was detected.": "얼굴이 감지되지 않았습니다.",
        "The file size is too large.": "파일 크기가 너무 큽니다.",
        "The face in the image is too large.": "이미지 속 얼굴이 너무 큽니다.",
        "The face in the image is too small.": "이미지 속 얼굴이 너무 작습니다.",
        "Multiple faces detected.": "여러 얼굴이 감지되었습니다.",
        "The face is not clear enough.": "얼굴이 충분히 선명하지 않습니다.",
        "Face detection failed.": "얼굴 감지에 실패했습니다.",
        "Please enter a value between 1 and 9999": "1에서 9999 사이의 값을 입력하세요.",
        "Please select which input your door sensor is connected to.": "도어 센서가 연결된 입력 단자를 선택하십시오.",
        "Add temp key failed, please try it again": "임시 키 추가에 실패했습니다, 다시 시도해 주세요",
        "Dis Not Support Dynamic QRCode Error.": "동적 QR코드를 지원하지 않는 오류입니다.",
        "QR code not exist": "QR 코드가 존재하지 않습니다",
        "The temp key has expired.": "임시 키가 만료되었습니다.",
        "The device is not in the office": "해당 장치는 사무실에 있지 않습니다.",
        "The device is already assigned.": "이미 해당 기기가 할당되었습니다.",
        "The device cannot be assigned to any user.": "이 장치는 어떤 사용자에게도 할당할 수 없습니다.",
        "You cannot select an option with fewer users than the current project members.": "현재 프로젝트 구성원보다 사용자가 적은 옵션을 선택할 수 없습니다.",
        "File check failed. Please download the latest template and try again.": "파일 검사에 실패했습니다. 최신 템플릿을 다운로드하고 다시 시도해 주세요.",
        "Dynamic QR Code not active.": "동적 QR 코드가 활성화되어 있지 않습니다.",
        "Dynamic QR Code not enable.": "동적 QR 코드가 활성화되어 있지 않습니다",
        "{0} not found.": "{0}을(를) 찾을 수 없습니다.",
        "Tier charge plan": "계단식 요금제",
        "Feature billing charge plan new": "기능 청구 요금제 신규",
        "Feature billing gradient charge plan": "기능 과금 그라디언트 요금제",
        "The exit time cannot be earlier than the entry time.": "출차 시간은 입차 시간보다 빠를 수 없습니다.",
        "User Name or Password": "사용자 이름 또는 비밀번호",
        "You can only link up to 5 sites.": "최대 5개의 사이트만 연결할 수 있습니다.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "해당 차량번호는 이미 입주민 차량으로 등록되어 있어 블랙리스트에 추가할 수 없습니다.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "해당 차량번호는 블랙리스트에 등록되어 있어 추가할 수 없습니다.",
        "Elevator not configured in company access floor.": "회사 출입 층에 엘리베이터가 설정되지 않았습니다.",
        "the device is not in the office": "해당 장치는 사무실에 있지 않습니다.",
        "A maximum of 1000 data items can be imported": "최대 1,000개의 데이터를 가져올 수 있습니다.",
        "Exit time cannot be later than the current time.": "출차 시간은 현재 시간보다 늦을 수 없습니다.",
        "You can only import a file at a time in the current parking lot.": "현재 주차장에서는 파일을 한 번에 하나만 가져올 수 있습니다.",
        "The license plate is already in the blocklist.": "해당 차량번호는 이미 블랙리스트에 등록되어 있습니다.",
        "Building name too long.": "건물명이 너무 깁니다.",
        "Unlock failed. Permission denied by user.": "문 열기 실패. 사용자가 권한을 거부했습니다.",
        "Please remove the sensor device(s) before disabling this feature.": "이 기능을 비활성화하기 전에 센서 장치(들)를 제거해 주세요.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "작업에 실패했습니다! 이 사용자는 일일 15개 기록 제한을 초과했습니다.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "프로젝트당 최대 {0}개의 공용 장치를 추가할 수 있습니다. 더 추가하려면 Akuvox 기술 지원팀(support{'@'}akuvox.com)에 문의해 주세요.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "프로젝트당 최대 {0}개의 직원 계정을 추가할 수 있습니다. 더 추가하려면 Akuvox 기술 지원팀(support{'@'}akuvox.com)에 문의해 주세요.",
        "cancel": "취소",
        "bluetooth": "블루투스",
        "Battery Level": "배터리 잔량",


    }
};
